import { html, css } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { Tabs } from "@omegagrid/tabs";
import { SplitContainerItem, ComponentFactory, ComponentStore, ComponentId, dom } from "@omegagrid/core";
import { AppComponent } from "@reporting/rp-app-host";
import { MessagesContainer, MarkdownContainer } from '../components';
import { Ticket } from '@reporting/rp-types/helpdesk';

@customElement('rp-helpdesk-ticket-container')
export class TicketContainer extends AppComponent {

	static styles = css`
		:host {
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			position: relative;
		}
	`;

	@property({type: Object})
	ticket: Ticket;

	@property({type: Array})
	items: SplitContainerItem[] = [{ id: 'messages', size: window.innerHeight / 1.7 }, { id: 'editor', size: null }];

	@property({type: Object})
	componentFactory: ComponentFactory;

	@query('og-splitcontainer')
	splitContainer: Tabs;

	edit() {
		this.dispatchEvent(new CustomEvent('edit', { bubbles: true, composed: true }));
	}

	save() {
		this.dispatchEvent(new CustomEvent('save', { bubbles: true, composed: true }));
	}

	async refresh() {
		(await this.componentStore.get('messages') as MessagesContainer)?.refresh();
	}

	componentStore = new ComponentStore(async (id: ComponentId) => {
		let component: MarkdownContainer | MessagesContainer;
		switch (id) {
			case 'messages':
				component = dom.createElement<MessagesContainer>('rp-helpdesk-messages-container');
				component.ticket = this.ticket;
		  		break;
		 	case 'editor':
				component = dom.createElement<MarkdownContainer>('rp-helpdesk-markdown-container');
				component.ticket = this.ticket;
				component.msgComponent = (await this.componentStore.get('messages')) as MessagesContainer;
		  		component.ticketComponent = this;
				break;
		}
		return component;
	});

	layout() {}

	render = () => html`
		<og-overlay defaultLoader></og-overlay>
        <og-splitcontainer
			orientation="vertical"
			.createComponent="${(id: ComponentId) => this.componentStore.get(id)}"
			.items="${this.items}"
			style="height: 100%;">
		</og-splitcontainer>
	`;

}
